<!--导入数据创建采购订单-->
<template>
    <div class="business-content-main" v-loading="saveLoading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-right">
                <div class="search-name">订单数据上传的Excel模板</div>
                <el-button type="text" class="search-btn" @click="downFile()">点击下载</el-button>
                <el-upload
                    :action="url"
                    :headers="headerObj"
                    :on-error="uploadErr"
                    accept=".xls,.xlsx"
                    :show-file-list="false"
                    :before-upload="beforeUpload"
                    :on-success="uploadSuccess"
                    :readonly="saveLoading || loading"
                    v-loading.fullscreen.lock="loading"
                >
                    <el-button size="small" icon="fa fa-file-excel-o" class="search-btn btn-primary"> 选择文件</el-button>
                </el-upload>
                <el-button size="small" icon="el-icon-upload" class="search-btn btn-primary" @click="handleExport" :readonly="saveLoading">保存数据</el-button>
                <div class="explain">
                    （* 导入的订单是未提交状态。）
                </div>
            </div>
        </div>

        <div class="table-ctn u-table-ctn">
            <u-table use-virtual :header-cell-style="{ background: '#F2F6FC' }" :border="true" :data="tableData" height="670" :row-height="34" style="width: 100%">
                <u-table-column label="调出仓库" show-overflow-tooltip min-width="85px" prop="OutWarehouse"> </u-table-column>
                <u-table-column label="调入仓库" show-overflow-tooltip min-width="85px" prop="IntoWarehouse"> </u-table-column>
                <u-table-column label="汽配编码" show-overflow-tooltip min-width="85px" prop="APCode"> </u-table-column>
                <u-table-column label="配件名称" show-overflow-tooltip min-width="85px" prop="GoodName"> </u-table-column>
                <u-table-column label="车型" show-overflow-tooltip min-width="85px" prop="AutoSerise"> </u-table-column>
                <u-table-column label="分类" show-overflow-tooltip min-width="85px" prop="Cate"> </u-table-column>
                <u-table-column label="品牌" show-overflow-tooltip min-width="85px" prop="Brand"> </u-table-column>
                <u-table-column label="产地" show-overflow-tooltip min-width="85px" prop="Origin"> </u-table-column>
                <u-table-column label="单位" show-overflow-tooltip min-width="85px" prop="Unit"> </u-table-column>
                <u-table-column label="库存" show-overflow-tooltip min-width="85px" prop="OriginalCount"> </u-table-column>
                <u-table-column label="调出数量" show-overflow-tooltip min-width="85px" prop="Count"> </u-table-column>
                <u-table-column label="成本价" show-overflow-tooltip min-width="85px" prop="CostPrice"> </u-table-column>
                <u-table-column label="调出总额" show-overflow-tooltip min-width="85px" prop="Count">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ (row.Count * row.CostPrice).toFixed(2) }}</div>
                    </template>
                </u-table-column>

            </u-table>
        </div>
        <el-progress type="circle" :percentage="percentage" class="saveProgress" :class="{ hide: !saveLoading }"></el-progress>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            pageTitle: '导入Excel',
            loading: false,
            saveLoading: false,
            tableData: [],
            userId: userMsg.EmployeeId,
            url: '/api/UploadFile/UploadCreateTransWarehouseExcel',
            headerObj: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            },         
            subData: {
                UserId: userMsg.EmployeeId,
                ToId: '', // 调拨单id
                OutWarehouseId: '',
                InWarehouseId: '', 
                Remark: '',
                TranCost: 0,
                DetailList: []
            },  
            percentage: 0, //进度
            recordId: ''
        };
    },
    mounted() {},
    methods: {
        downFile() {
            let a = document.createElement('a');
            a.href = `/download/移库调仓导入模板.xlsx`; // 这里的请求方式为get，如果需要认证，接口上需要带上token
            a.target = '_blank';
            a.click();
        },
        uploadSuccess(res) {
            if (res.errcode == 0) {
                this.importTramsferOrder(res.data);
            } else {
                this.$util.errorMsg(res.errmsg);
                this.upLoading = false;
            }
            this.loading = false;
        },
        uploadErr(error) {
            this.loading = false;
            const result = JSON.parse(error.message);
            this.$util.errorMsg(result.message);
        },
        beforeUpload(file) {
            this.loading = true;
            this.tableData = [];
        },
        //计算导入开单货物的在库数量
        importTramsferOrder(dataList){
            let that = this;
            that.$util
                .axiosPost({
                    url: '/api/EntpTransferOrder/GetImportTransferOrderInventory',
                    data: dataList
                })
                .then(res => {
                    if(res.errcode == 0){
                        if(res.data.length != 0){
                            this.tableData = res.data;
                        }
                    }else{
                        this.$util.warningMsg(res.errmsg);
                        this.upLoading = false;

                    }

                })
                .catch(() => {
                    this.upLoading = false;

                });
        },
		//保存提交
        handleExport() {
            let that = this;
            let _list = that.tableData;
            if (!that.tableData[0]) {
                that.$util.warningMsg('请添加文件');
                return;
            }
            for (let i = 0; i < _list.length; i++) {
                // consloe.log('5' > '16') // true 如果要比较数值，不能用char比较大小
                if (parseInt(_list[i].Count) > parseInt(_list[i].OriginalCount)) {
                    that.$util.warningMsg('第'+ (i+1) +'列调出数量不得大于库存数量');
                    return;
                }
            }

            that.uploadStartRecords('上传创建调拨单商品项数：' + that.tableData.length);

            that.subData.DetailList = that.tableData;
            that.subData.OutWarehouseId = that.tableData[0]['OutWarehouseId'];
            that.subData.InWarehouseId = that.tableData[0]['IntoWarehouseId'];
            let url = '/api/EntpTransferOrder/NewSaveEnterpriseTransferOrder';
            that.$util
                .axiosPost({
                    url: url,
                    data: that.subData
                })
                .then(res => {
                    that.$util.successMsg('调拨单创建成功');
                    that.uploadEndRecords(res.errmsg);
                    that.$store.commit('updateNeedRefresh', true);
                        setTimeout(() => {
                            that.$router.push('/inventoryManage/transWarehouse');
                        }, 1000);
                })
                .catch(() => {
                    that.saving = false;
                });
        },
        uploadStartRecords(desc) {
            let that = this;
            let params = { Type: 10, OpDesc: desc };
            that.$util.uploadStartRecords(params).then(res => {
                if (res.data) that.recordId = res.data;
            });
        },
        uploadEndRecords(desc) {
            let that = this;
            if (that.recordId) {
                let params = { RecordId: that.recordId, OpDesc: desc };
                that.$util.uploadEndRecords(params);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.search-btn {
    margin-left: 0;
    margin-right: 20px;
}
.explain {
    flex-shrink: 0;
    margin: 0 10px 10px;
    height: 32px;
    line-height: 32px;
    color: #ef7a82;
}
.saveProgress {
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 99999;
}
.el-icon-warning-outline {
    color: orange;
    margin-right: 5px;
}
</style>
